import { CommonTableRequestType, CommonTableResponseType } from 'src/models/Table';
import { SafeAnyType } from 'src/utils/safeAny';
import { CommonApiErrorActionType } from 'src/models/BaseApi';
import { AccountOrganizerExternalContributionAddEditDonationFormProps } from 'src/pages/Account/Organizer/ExternalContributions/components/modals/AddEditDonation';
import { AccountOrganizerExternalContributionLoadResponseType } from 'src/models/Account/Organizer/externalContributions';
import { StateFormReturnType } from 'src/utils/stateForm';
import { StripeApi } from 'src/utils/stripe';
import { PartialRecord } from 'src/utils/types';

export enum AccountOrganizerEnum {
  EXTERNAL_CONTRIBUTIONS = 'externalContributions',

  CONTRIBUTIONS_SUPPORTERS = 'contributionsSupporters',
}

export type AccountOrganizerGetListStartType = {
  filter: CommonTableRequestType;
  type: AccountOrganizerEnum;
  additionalParams?: Record<string, SafeAnyType>;
};

export type AccountOrganizerGetListOkType = { data: CommonTableResponseType<SafeAnyType>; type: AccountOrganizerEnum };

export type AccountOrganizerGetListErrorType = { error: CommonApiErrorActionType; type: AccountOrganizerEnum };

export type AccountOrganizerSaveContributionStartType = {
  formProps: StateFormReturnType<AccountOrganizerExternalContributionAddEditDonationFormProps>;
  resetData: (data: AccountOrganizerExternalContributionLoadResponseType) => void;
  stripe: StripeApi;
  submitPayPalPayment: ((orderId: string) => Promise<SafeAnyType>) | undefined;
};
export type AccountOrganizerSaveContributionOkType = {
  data: AccountOrganizerExternalContributionLoadResponseType;
};
export type AccountOrganizerChangeAdditionalListInfoType = {
  data: PartialRecord<string, SafeAnyType>;
  type: AccountOrganizerEnum;
};

export type AccountOrganizerChangeDataInListType = {
  id: number | string;
  data: PartialRecord<string, SafeAnyType>;
  type: AccountOrganizerEnum;
};

export type AccountOrganizerTransactionDetailsResponseType = {
  Info: { Key: string; Value: string }[];
};

export type AccountOrganizerRecurringContributionStartType = {
  stripe: StripeApi;
  ContributionID: number;
};

export type AccountOrganizerRecurringPayPalContributionStartType = {
  ContributionID: number;
  submitPayPalPayment: (orderId: string) => Promise<SafeAnyType>;
};

export type AccountOrganizerContributionStartType = {
  stripe: StripeApi;
  PaymentID: number;
  PaymentMethodId: string;
  wasStripeDataEntered: boolean;
};

export type AccountOrganizerPayPalContributionStartType = {
  submitPayPalPayment: ((orderId: string) => Promise<SafeAnyType>) | undefined;
  PaymentID: number;
  wasPayPalDataEntered: boolean;
};

export type AccountOrganizerClientSecret = {
  ClientSecret: string;
};

export type AccountOrganizerAuthorizationOrder = {
  AuthorizationOrderId: string;
};

export type AccountOrganizerRecovery = {
  ClientSecret: string;
  PayPalOrderId: string;
};

export type PaymentIdRequestType = {
  PaymentID: number;
};

/** processTeamMembers */
export type AccountOrganizerProcessTeamMembersRequestType = {
  FileName: string;
  Notify: boolean;
  PermanentUrl: string;
  RegistrationTypes: [{ TypeID: number }];
  RegistrationTypeId: number;
  TotalErrorRecords: number;
  TotalRecords: number;
  TotalValidRecords: number;
};

export type AccountOrganizerProcessTeamMembersResponseType = AccountOrganizerProcessTeamMembersRequestType & {
  ImportProgressGroupName: string;
  ImportFinishedGroupName: string;
};
/** end processTeamMembers */

export enum CampaignLimitationValueTypeEnum {
  percentage = 1,
  flat,
}
